export const DISABLE_POST_COMMENTS_REQUEST = 'post/DISABLE_COMMENTS_REQUEST';
export const DISABLE_POST_COMMENTS_SUCCESS = 'post/DISABLE_COMMENTS_SUCCESS';
export const DISABLE_POST_COMMENTS_FAILURE = 'post/DISABLE_COMMENTS_FAILURE';

export function disablePostComments(id) {
  return (dispatch, getState, { request }) => {
    dispatch({
      type: DISABLE_POST_COMMENTS_REQUEST,
    });

    const promise = request.post(`/_api/posts/${id}/disableComments`);

    return promise
      .then(post =>
        dispatch({
          type: DISABLE_POST_COMMENTS_SUCCESS,
          payload: post,
        })
      )
      .catch(() =>
        dispatch({
          type: DISABLE_POST_COMMENTS_FAILURE,
        })
      )
      .then(() => promise);
  };
}



// WEBPACK FOOTER //
// ./app/actions/disable-post-comments.js